import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SupportAccessOut } from '../models/support.models';

/**
 * Клієнтський API ролі SUPPORT. Для не-support бек повертає порожній масив.
 */
@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private http = inject(HttpClient);
  private readonly API_URL = `${environment.apiUrl}/support`;

  /** Організації, між якими може перемикатися поточний support. */
  getOrganizations(): Observable<SupportAccessOut[]> {
    return this.http.get<SupportAccessOut[]>(`${this.API_URL}/organizations`);
  }
}
